import { render, staticRenderFns } from "./AuditTopic.vue?vue&type=template&id=4d9e7c5a&"
import script from "./AuditTopic.vue?vue&type=script&lang=js&"
export * from "./AuditTopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports